import React from 'react';

// ConfigurableButton
// Props:
// - text: string (button label)
// - children: node (optional, overrides text)
// - bgColor: CSS color for background
// - color: CSS color for text
// - width: CSS width (e.g. '100px' or '100%')
// - height: CSS height (e.g. '40px')
// - borderRadius: CSS border-radius
// - onClick: function
// - disabled: boolean
// - style: extra style object to merge
// - className: extra class names

const ConfigurableButton = ({
  text = 'Button',
  children,
  bgColor = '#3b82f6',
  color = '#ffffff',
  width = 'auto',
  height = '40px',
  borderRadius = '8px',
  onClick = () => {},
  disabled = false,
  style = {},
  className = '',
  type = 'button',
}) => {
  const baseStyle = {
    background: bgColor,
    color,
    width,
    height,
    borderRadius,
    border: 'none',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: typeof width === 'string' && width !== 'auto' ? '0 12px' : '0 16px',
    fontSize: '0.95rem',
    fontWeight: 600,
    cursor: disabled ? 'not-allowed' : 'pointer',
    opacity: disabled ? 0.65 : 1,
    transition: 'transform 120ms ease, box-shadow 120ms ease',
    boxShadow: 'none',
    ...style,
  };

  return (
    <button
      type={type}
      className={className}
      style={baseStyle}
      onClick={disabled ? undefined : onClick}
      disabled={disabled}
    >
      {children || text}
    </button>
  );
};

export default ConfigurableButton;
